<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="ticket-edit-confirm-context-menu-container" [planPositioning]="menuData$">
	<!-- 
		ugh, material... to open a menu, it requires another dom element with matMenuTriggerFor to get access to the
		trigger.openMenu method. Soo... instead of a button, have a 0x0 div I guess.
	-->
	<div #ticketEditContextMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="ticketEditContextMenu"></div>

	<!-- Menu Items -->
	<mat-menu
		#ticketEditContextMenu="matMenu"
		class="context-menu"
		[ngSwitch]="hasPredecessors$ | async"
		[hasBackdrop]="false"
	>
		<!-- Set as Predecessor -->
		<button mat-menu-item (click)="addPredecessor()" *ngSwitchDefault automationId="setAsPredecessor">
			<mat-icon color="primary">add_circle</mat-icon>
			<span>{{ appStrings.EDIT_CONFIRM_ADD_AS_PREDECESSOR }}</span>
		</button>

		<div *ngSwitchCase="true">
			<!-- Edit Predecessor -->
			<button
				*ngIf="dependencyAttributesFeatureFlag$ | async"
				mat-menu-item
				(click)="editPredecessor()"
				automationId="editPredecessor"
			>
				<mat-icon color="primary">edit</mat-icon>{{ appStrings.EDIT_CONFIRM_EDIT_PREDECESSOR }}
			</button>
			<!-- Remove Predecessor -->
			<button mat-menu-item (click)="removePredecessor()" automationId="removePredecessor">
				<mat-icon color="primary">do_not_disturb_on</mat-icon>
				<span>{{ appStrings.EDIT_CONFIRM_REMOVE_AS_PREDECESSOR }}</span>
			</button>
		</div>
	</mat-menu>
</div>
